<script lang="ts" setup>
import { AppButton, AppSvgIcon } from '@libs/ui';

import type { HomeFlightData } from './AirportSelector.model';

interface HomeAirportSelectorButtonProps {
  homeFlightData: HomeFlightData;
}
const props = defineProps<HomeAirportSelectorButtonProps>();
</script>

<template>
  <AppButton
    type="secondary"
    state="enabled"
    size="small"
    :icon="{
      size: '18',
      name: 'chevronDown',
      position: 'left',
    }"
  >
    <div class="home-airport-button">
      <AppSvgIcon name="airplaneTakeoff" size="18" />
      {{ props.homeFlightData.airport.name }}
    </div>
  </AppButton>
</template>

<style lang="scss" scoped>
.home-airport-button {
  display: flex;
  align-items: center;
  gap: var(--spacing-8);
}
</style>
